import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import Checkbox from '~/glm/components/guest-list/checkbox.jsx';
import NamesCell from '~/glm/components/guest-list/cells/names-cell';
import SelectionCell from '~/glm/components/guest-list-table/cells/selection-cell';
import GdsGuest from '~/glm/models/gds/gds-guest-model.js';
import EventCollection from '~/glm/models/gds/event-collection';
import ClickCell from '~/glm/components/guest-list/cells/click-cell';
import TextCell from '~/glm/components/guest-list/cells/text-cell.jsx';
import ContactInfoCell from '~/glm/components/guest-list/cells/contact-info-cell.jsx';
import RsvpCell from '~/glm/components/guest-list/cells/rsvp-cell';
import Invitation from '~/glm/models/gds/gds-invitation-model';
import cellStyles from './guest-row.scss';
import styles from './row.scss';

@observer
class OverviewGuestRow extends Component {
  static propTypes = {
    guest: PropTypes.instanceOf(GdsGuest).isRequired,
    gdsEvents: PropTypes.instanceOf(EventCollection),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    household: PropTypes.instanceOf(GdsHouseholdModel).isRequired,
    editHousehold: PropTypes.func.isRequired,
    trackThankYou: PropTypes.func.isRequired,
    trackMeal: PropTypes.func.isRequired,
    invitation: PropTypes.instanceOf(Invitation),
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  householdMembers = () => {
    const { household } = this.props;

    return household.members.map(value => value);
  };

  renderRsvpCells = () => {
    const { gdsEvents, gdsUiState, guest, analyticsStore } = this.props;
    return gdsEvents.nonReceptionEvents.map(gdsEvent => {
      const { id } = gdsEvent;

      return (
        <div key={id} className={cellStyles.rsvpContainer}>
          <RsvpCell
            gdsUiState={gdsUiState}
            event={gdsEvent}
            gdsInvitation={guest.getInvitationByEvent(id)}
            guest={guest}
            analyticsStore={analyticsStore}
          />
        </div>
      );
    });
  };

  toggleGuestSelection = () => {
    const { guest } = this.props;
    const newStatus = !guest.selected;

    guest.setSelected(newStatus);
  };

  render() {
    const { household, editHousehold, guest } = this.props;
    return (
      <tr key={`guest-row-${guest.id}`} className={styles.individualRow}>
        <SelectionCell>
          <Checkbox
            id={`household-checkbox-${guest.id}`}
            className={styles.selectionCheckbox}
            checked={guest.selected}
            onClick={this.toggleGuestSelection}
          />
        </SelectionCell>

        <NamesCell key={`name-${guest.id}`} onClick={() => editHousehold(household)} guests={[guest]} />

        <ClickCell onClick={() => editHousehold(household)}>
          <ContactInfoCell household={household} />
        </ClickCell>

        {this.renderRsvpCells()}

        <ClickCell onClick={() => editHousehold(household)}>
          <TextCell type="notes" value={household.coupleNote} className={cellStyles.notes} />
        </ClickCell>
      </tr>
    );
  }
}

export default OverviewGuestRow;
